import { render, staticRenderFns } from "./TheBaseAuth.vue?vue&type=template&id=ba7bf3b4"
import script from "./TheBaseAuth.vue?vue&type=script&lang=ts"
export * from "./TheBaseAuth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports